export default () => ({
    loading: false,
    pendingRefresh: false,
    user: null,
    tokens: null,
    sessionExpiration: null,
    sessionTimeout: null,
    sessionInterval: null
})